import { QuickbooksDesktopLogo } from "./Resources/QuickbooksDesktopLogo";
import { Sage50Logo } from "./Resources/Sage50Logo";

export const Connectors = {
  sage50: { Name: "Sage 50", Logo: Sage50Logo },
  quickbooksdesktop: {
    Name: "QuickBooks Desktop",
    Logo: QuickbooksDesktopLogo,
  },
  qbwc: {
    Name: "QuickBooks Desktop (WC)",
    Logo: QuickbooksDesktopLogo,
  },
};

export type ConnectorType = keyof typeof Connectors;

export function GetConnector(key: ConnectorType) {
  const found = Connectors[key];

  if (
    found.Name === "QuickBooks Desktop" ||
    found.Name === "QuickBooks Desktop (WC)"
  ) {
    return <QuickbooksDesktopLogo title={found.Name} />;
  }

  return <Sage50Logo title={found.Name} />;
}
